import React, {useState,useEffect , useRef } from "react";
import {useLocation, useParams} from "react-router-dom";
import axios from "axios";
import {useAuthDispatch,useAuthState} from "../../Context/auth-context";
import {useMediaQuery} from "beautiful-react-hooks";
import { Link} from "react-router-dom";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SlideSHowLogin from "../login/SlideShowLogin";
import SlideSHowLoginFast from "./SlideSHowLoginFast";
import {actionTypes} from "../../Context/reducer";
import ConfirmationAuth from "../ConfirmationAuth";
import { string } from "prop-types";

const BASEURL = 'https://api.sinatether.com/Auth/login/'

  

const fetchToken = async (Phone,token,source)=>{
        return axios.post(BASEURL,{'phone':Phone,"token":token,'source':source},
            {withCredentials:true})
    }


export default function FastAuthentication(){
    const navigate =  useNavigate()
    const  YOUR_SITE_KEY = '6LcQ-54gAAAAAMvAhDj5nKog3L882SfR9WxFtv99'
    const {isAuth} = useAuthState()

    const dispatch = useAuthDispatch()

    const [Phone,setPhone] = useState("")
    const [error,seterror] = useState('')
    const [isLoading,setIsLoading] = useState(false)
    const isSmall = useMediaQuery('(max-width: 768px)')
    const [cardNumber, setcardNumber] = useState('');
    const [meli, setMeli] = useState('');
    const [logout,setLogout] = useState()

    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    const [errorCodeMeli, seterrorCodeMeli] = useState('');
    const [errorDate, seterrorDate] = useState('');
    const [errorBank, seterrorBank] = useState('');
    const yearRef = useRef(null);
    const monthRef = useRef(null);
    const dayRef = useRef(null);
    const meliRef = useRef(null);
    const cardRef = useRef(null);







    
    async function handelLogout(){

        setLogout(true)

    }


    useEffect(() => {
         function fetchData() {
            if(logout){
          // You can await here
          const response =  axios.get('https://api.sinatether.com/Auth/Logout/',{
            withCredentials:true
        }).then((res)=>{
            if (res.status == 200){
                if(res.data['status'] == 200){
                dispatch({
                    type:actionTypes.LOGOUT
                })
                 console.log(res)
                 window.location.replace('/login')
                }





            }
        }).catch((error)=>{
            if (error){
                toast.error("مشکلی پیش امده است مجددا تلاش فرمایید")
            }
        })
    }
          // ...
        }
        fetchData();
      }, [logout]);




    const [inputValue, setInputValue] = useState('');




    const formatNumber = (num) => {
        return num.toString().padStart(2, '0');
      };


    function isValidIranianNationalCode(code) {
        if (!/^\d{10}$/.test(code)) {
          return false;
        }
      
        const checkDigit = parseInt(code.charAt(9), 10);
        let sum = 0;
      
        for (let i = 0; i < 9; i++) {
          sum += parseInt(code.charAt(i), 10) * (10 - i);
        }
      
        const remainder = sum % 11;
      
        return (remainder < 2 && checkDigit === remainder) || (remainder >= 2 && checkDigit === 11 - remainder);
      }





      function validateCard(card) {
        if (typeof card === 'undefined'
          || card === null
          || card.length !== 16) {
          return false;
        }
        let cardTotal = 0;
        for (let i = 0; i < 16; i += 1) {
          const c = Number(card[i]);
          if (i % 2 === 0) {
            cardTotal += ((c * 2 > 9) ? (c * 2) - 9 : (c * 2));
          } else {
            cardTotal += c;
          }
        }
        return (cardTotal % 10 === 0);
      }




    const formatCardNumber = (value) => {
        return value.replace(/\s?/g, '').replace(/(\d{4})/g, '$1 ').trim();
    };



    const removeSpaces = (value) => {
        return value.replace(/\s+/g, '');
    };


    const handleChange = (event) => {

        var name = event.target.name
        var value = event.target.value

        if (name == 'meli'){
            setMeli(value)
            if (isValidIranianNationalCode(value)){
                seterrorCodeMeli('')
                yearRef.current.focus();

            }else{
                seterrorCodeMeli('کد ملی خود را به درستی وارد کنید')
            }

        }
        else if (name == 'day'){

            setDay(value)

            if(value.length == 2){
                seterrorDate('')
                cardRef.current.focus();


            }

        }
        else if (name == 'month'){

            setMonth(value)

            if(value.length == 2){
                seterrorDate('')
                dayRef.current.focus();


            }

            
            
        }else if (name == 'year'){

            console.log(value)
            setYear(value)

            if(value.length == 4){
                seterrorDate('')
                monthRef.current.focus();


            }else{
                seterrorDate('تاریخ تولد خود را به درستی وارد کنید')
            }
            
        }else if (name == 'card_number'){
            setcardNumber(formatCardNumber(value))

            if (validateCard(removeSpaces(value))){
                seterrorBank('')
            }else{
                seterrorBank('شماره کارت خود را به درستی وارد نمایید')
            }
            
        }



      setInputValue(event.target.value);
    };

















    



    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
    canonical.href = `https://sinatether.com/login`;
    }

    let query = useQuery()
    try{
        var source = localStorage.getItem('source')
        var ref = localStorage.getItem('ref')

        if (!source){
         source = query.get("utm_source")
        localStorage.setItem("source",source)
       }
       if(!ref){
         ref =  query.get("ref")
         localStorage.setItem("ref",ref)


       }
    }
    catch{
        var source = ''
        
    }








     
    function useQuery() {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
        }



        useEffect(() => {
            ReactRecaptcha3.init(YOUR_SITE_KEY).then(
              (status) => {
              }
            );
          }, [])




   function HandelClick(event) {
    event.preventDefault()





        if (!meli || !cardNumber || !year || !month || !day ){


            toast.error('اطلاعات را بدرستی تکمیل نمایید')
            return



        }


        if (errorBank || errorCodeMeli || errorDate){
            toast.error('اطلاعات را بدرستی تکمیل نمایید')
            return
        }




        let meliEng = toEnglishNumber(meli)
        let cardNumberEng = toEnglishNumber(cardNumber)
        cardNumberEng = removeSpaces(cardNumberEng)
        let yearEng = toEnglishNumber(year)
        let monthEng = toEnglishNumber(month)
        let dayEng = toEnglishNumber(day)
        dayEng = formatNumber(dayEng)
        monthEng = formatNumber(month)
        let birth_date = String(yearEng) + String(monthEng) + String(dayEng)

        
        const monthInt = parseInt(month, 10);
        const dayInt = parseInt(day, 10);
        const yearInt = parseInt(year, 10);

        if (yearInt > 1403 && yearInt < 1300){
            seterrorDate('تاریخ تولد خود را به درستی وارد کنید');
            return;
        }
        if (monthInt > 12) {
            seterrorDate('تاریخ تولد خود را به درستی وارد کنید');
            return;
        }

        if (dayInt > 31) {
            seterrorDate('تاریخ تولد خود را به درستی وارد کنید');
        return;
        }
        console.log(birth_date)
        console.log(cardNumberEng)
        console.log(meliEng)





        setIsLoading(true)




        const  formdata = new FormData();


        formdata.append('nationalCode',meliEng)
        formdata.append('birthDate',birth_date)
        formdata.append('cardNumber',cardNumberEng)





        axios.post('https://api.sinatether.com/Auth/request_fast_authentication/',formdata,{
           withCredentials:true,},).then((response) =>{
            console.log(response)
            if (response.status == 200){
                if (response.data['status'] == 200)
                {

                    setDialogOpen(true)
                   
                    
                }else {
                    

                    toast.error(response.data['message'])
                }
                setIsLoading(false)



            }

                
               
                

        }

        ).catch(error =>{
            if (error)
            {
                toast.error('اطلاعات به درستی ارسال نشد دوباره امتحان کنید')
                setIsLoading(false)

            }

            }
        )


   
       

   }

  
   function toEnglishNumber(strNum) {
    var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    var an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
    var cache = strNum;
    for (var i = 0; i < 10; i++) {
        var regex_fa = new RegExp(pn[i], 'g');
        var regex_ar = new RegExp(an[i], 'g');
        cache = cache.replace(regex_fa, en[i]);
        cache = cache.replace(regex_ar, en[i]);
    }
    return cache;
}

   function handelCheck(event){
        var pattern = new RegExp(/^09[0-9]{9}/);
        var pattern1 =  new RegExp(/^@#@_[0-9]{2}/)
        let p = event.target.value
        if (pattern1.test(p)){
            if (p.length == 6){
                seterror('')
                setPhone(p)
                return
            }
        }




        p = toEnglishNumber(p)




       /*if(p.length==11)
       {*/
           if (!pattern.test(p))
            {
            seterror('لطفا شماره تلفن خود را درست وارد نمایید')
            }else if(p.length==11) {
               seterror('')
               setPhone(p)
           }
           else {
                           seterror('لطفا شماره تلفن خود را درست وارد نمایید')
           }
      /* }
       else {
           seterror('شماره تلفن وارد شده صحیح نیست!')
       }*/


   }




   
   const months = [
    { value: '01', label: 'فروردین' },
    { value: '02', label: 'اردیبهشت' },
    { value: '03', label: 'خرداد' },
    { value: '04', label: 'تیر' },
    { value: '05', label: 'مرداد' },
    { value: '06', label: 'شهریور' },
    { value: '07', label: 'مهر' },
    { value: '08', label: 'آبان' },
    { value: '09', label: 'آذر' },
    { value: '10', label: 'دی' },
    { value: '11', label: 'بهمن' },
    { value: '12', label: 'اسفند' }
  ];






  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {

    setDialogOpen(false);
    navigate('/')
  };

  const handleConfirmPurchase = () => {
    setDialogOpen(false);
    navigate('/top-authentication')

  };

  



    return(
        <div className="fast-auth5050">


<ConfirmationAuth 
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmPurchase}
      />



       <>


        





           {isSmall ?
               <>

                          {/* <div id="preloader">
                                   <div className="sk-three-bounce">
                                       <div className="sk-child sk-bounce1">

                                       </div>
                                       <div className="sk-child sk-bounce2">

                                       </div>
                                       <div className="sk-child sk-bounce3">

                                       </div>
                                   </div>
                    </div> */}


<SlideSHowLoginFast>

<div className="card-size2024">
                   <div className="container h-100">
                       <div className="row justify-content-center h-100 align-items-center">
                           <div className="">
                               <div className="mini-logo text-center my-2">
                               </div>
                               <div className="auth-form card custom-shadow">
                                   <div className="card-body">
                                       <div className="row text-center pb-4">
                                       <Link to={'/'}>

                                        <div>
                                        <img className={'logo-desk-css2'} src={'./images/mob-logo.svg'} alt={'سینا تتر'}/>


                                        </div>

                                       </Link>

 


                                       </div>

                                       <div>

                                       <div className="khsfsfiewrwr24242">
                                            <div className="title-first-leve">
                                                احراز هویت سطح یک
                                            </div>

                                            <div className="d-flex-divee2424245">

                                                <div className="confsje353535242">
                                                    امکانات:
                                                </div>

                                                <div className="sub-ewrjbwr243524232 ">
                                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                                <div className="confsje353535242">
                                                    واریز
                                                </div>
                                                </div>


                                                <div className="sub-ewrjbwr243524232">
                                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                                <div className="confsje353535242">
                                                    خرید و فروش
                                                </div>
                                                </div>


                                                
                                                
                                            </div>

                                        </div>

                                        <div className="adahd24243509824">
                                        شماره‌کارت، شماره همراه و کدملی باید متعلق به یک شخص باشد.
                                        </div>

                                        <div>

                                        </div>

                                        <div>


                                        <div>
                        <div class="text-medium mt-2 mb-2 curser" onClick={handelLogout}><svg id="Group_132" data-name="Group 132" xmlns="http://www.w3.org/2000/svg" width="8.983" height="8.992" viewBox="0 0 27.983 51.992"><path id="Path_4" data-name="Path 4" d="M14,52a2,2,0,0,0,1.41-.59l24-24a2,2,0,0,0,0-2.82l-24-24a1.994,1.994,0,1,0-2.82,2.82L35.17,26,12.59,48.59A2,2,0,0,0,14,52Z" transform="translate(-12.008 -0.008)" fill="#167f77"></path></svg><span class="font-23424 pl-1 text-price">اصلاح شماره تلفن</span></div>
                        </div>


                        <div className="google-input-container mgtb18">
                        <input
                            type="text"
                            className={`google-input   ${meli ? 'has-value' : '' }`}
                            value={meli}
                            name="meli"
                            maxLength={10}
                            ref={meliRef}
                            onChange={handleChange}
                            
                        />
                        <label className="google-placeholder">کد ملی</label>


                        <div className={'text-danger error-message2024'}>
                                                   {errorCodeMeli}
                                               </div>
                        </div>












                        <div className="mgtb18">

                            <div className="sdhfs24354msff-sdsff2324">
                                تاریخ تولد:
                            </div>

                            <div className="dsjhg2y4232323">

                        <div className="google-input-container">
                        <input
                            type="text"
                            className={`google-input   ${day ? 'has-value' : '' }`}
                            value={day}
                            name="day"
                            onChange={handleChange}
                            ref={dayRef}
                            maxLength={2}

                        />
                        <label className="google-placeholder">روز</label>
                        </div>



                        <div className="google-input-container mgrl12">
                        <input
                            type="text"
                            className={`google-input   ${month ? 'has-value' : '' }`}
                            value={month}
                            name="month"
                            onChange={handleChange}
                            ref={monthRef}
                            maxLength={2}
                        />
                        <label className="google-placeholder">ماه</label>
                        </div>










                        <div className="google-input-container">
                        <input
                            type="text"
                            className={`google-input   ${year ? 'has-value' : '' }`}
                            value={year}
                            name="year"
                            onChange={handleChange}
                            ref={yearRef}
                            maxLength={4}

                        />
                        <label className="google-placeholder">سال </label>
                        </div>


                        </div>
                        <div className={'text-danger error-message2024'}>
                                                   {errorDate}
                                               </div>



                        </div>

                     


                        <div className="google-input-container mgtb18">
                        <input
                            type="text"
                            className={`google-input   ${cardNumber ? 'has-value' : '' }`}
                            value={cardNumber}
                            name="card_number"
                            ref={cardRef}
                            maxLength={19}
                            onChange={handleChange}
                        />
                        <label className="google-placeholder">شماره کارت</label>

                        <div className={'text-danger error-message2024'}>
                                                   {errorBank}
                                               </div>
                        </div>






                                                            </div>






                                       </div>









                                       <div>

                                        <button className="button-submit123244212" onClick={HandelClick} disabled={isLoading ? true : false}>
                                        {isLoading ?
                                                                    <img className="jsdhshgd" src={'../img-camp/loading5.svg'}/>
 

                                                :
                                                <>
                                            ثبت اطلاعات
                                            </>
                                        }
                                        </button>


                                       </div>
                                       

      

                                       



                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>


               </SlideSHowLoginFast>


                    





             </>


               :
               <>
                       <SlideSHowLogin>



                        {/* <div id="preloader">
                                   <div className="sk-three-bounce">
                                       <div className="sk-child sk-bounce1">

                                       </div>
                                       <div className="sk-child sk-bounce2">

                                       </div>
                                       <div className="sk-child sk-bounce3">

                                       </div>
                                   </div>
                    </div> */}



                          <div className="card-size2024">
                   <div className="container h-100">
                       <div className="row justify-content-center h-100 align-items-center">
                           <div className="">
                               <div className="mini-logo text-center my-2">
                               </div>
                               <div className="auth-form card custom-shadow">
                                   <div className="card-body">
                                       <div className="row text-center pb-4">
                                       <Link to={'/'}>

                                        <div>
                                        <img className={'logo-desk-css2'} src={'./images/mob-logo.svg'} alt={'سینا تتر'}/>


                                        </div>

                                       </Link>

 


                                       </div>

                                       <div>


                                       <div className="khsfsfiewrwr24242">
                                            <div className="title-first-leve">
                                                احراز هویت سطح یک
                                            </div>

                                            <div className="d-flex-divee2424245">

                                                <div className="confsje353535242">
                                                    امکانات:
                                                </div>

                                                <div className="sub-ewrjbwr243524232 ">
                                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                                <div className="confsje353535242">
                                                    واریز بدون محدودیت
                                                </div>
                                                </div>


                                                <div className="sub-ewrjbwr243524232">
                                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                                <div className="confsje353535242">
                                                    خرید و فروش بدون محدودیت
                                                </div>
                                                </div>


                                                
                                                
                                            </div>

                                        </div>

                                     

                                        <div className="adahd24243509824">
                                        شماره‌کارت، شماره همراه و کدملی باید متعلق به یک شخص باشد.
                                        </div>

                                        <div>

                                        </div>

                                        <div>


                        

                                        <div>
                        <div class="text-medium mt-2 mb-2 curser" onClick={handelLogout}><svg id="Group_132" data-name="Group 132" xmlns="http://www.w3.org/2000/svg" width="8.983" height="8.992" viewBox="0 0 27.983 51.992"><path id="Path_4" data-name="Path 4" d="M14,52a2,2,0,0,0,1.41-.59l24-24a2,2,0,0,0,0-2.82l-24-24a1.994,1.994,0,1,0-2.82,2.82L35.17,26,12.59,48.59A2,2,0,0,0,14,52Z" transform="translate(-12.008 -0.008)" fill="#167f77"></path></svg><span class="text-medium pl-1 text-price">اصلاح شماره تلفن</span></div>
                        </div>




                        <div className="google-input-container mgtb18">
                        <input
                            type="text"
                            className={`google-input   ${meli ? 'has-value' : '' }`}
                            value={meli}
                            name="meli"
                            maxLength={10}
                            ref={meliRef}
                            onChange={handleChange}
                            
                        />
                        <label className="google-placeholder">کد ملی</label>


                        <div className={'text-danger error-message2024'}>
                                                   {errorCodeMeli}
                                               </div>
                        </div>












                        <div className="mgtb18">

                            <div className="sdhfs24354msff-sdsff2324">
                                تاریخ تولد:
                            </div>

                            <div className="dsjhg2y4232323">

                        <div className="google-input-container">
                        <input
                            type="text"
                            className={`google-input   ${day ? 'has-value' : '' }`}
                            value={day}
                            name="day"
                            onChange={handleChange}
                            ref={dayRef}
                            maxLength={2}

                        />
                        <label className="google-placeholder">روز</label>
                        </div>



                        <div className="google-input-container mgrl12">
                        <input
                            type="text"
                            className={`google-input   ${month ? 'has-value' : '' }`}
                            value={month}
                            name="month"
                            onChange={handleChange}
                            ref={monthRef}
                            maxLength={2}
                        />
                        <label className="google-placeholder">ماه</label>
                        </div>










                        <div className="google-input-container">
                        <input
                            type="text"
                            className={`google-input   ${year ? 'has-value' : '' }`}
                            value={year}
                            name="year"
                            onChange={handleChange}
                            ref={yearRef}
                            maxLength={4}

                        />
                        <label className="google-placeholder">سال </label>
                        </div>


                        </div>
                        <div className={'text-danger error-message2024'}>
                                                   {errorDate}
                                               </div>



                        </div>

                     


                        <div className="google-input-container mgtb18">
                        <input
                            type="text"
                            className={`google-input   ${cardNumber ? 'has-value' : '' }`}
                            value={cardNumber}
                            name="card_number"
                            ref={cardRef}
                            maxLength={19}
                            onChange={handleChange}
                        />
                        <label className="google-placeholder">شماره کارت</label>

                        <div className={'text-danger error-message2024'}>
                                                   {errorBank}
                                               </div>
                        </div>

                       




                                                            </div>






                                       </div>









                                       <div>

                                        <button className="button-submit123244212" onClick={HandelClick} disabled={isLoading ? true : false}>
                                        {isLoading ?
                                                                    <img className="jsdhshgd" src={'../img-camp/loading5.svg'}/>
 

                                                :
                                                <>
                                            ثبت اطلاعات
                                            </>
                                        }
                                        </button>


                                       </div>
                                       

      

                                       



                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>


               </SlideSHowLogin>



                   </>






           }




       </>



        </div>


    )
}